import type { ReactNode } from 'react';
import { CheckCircleFilled, ClockCircleOutlined, EyeOutlined } from '@ant-design/icons';
import type { OverallStatus } from '@/api/types';
import { useI18n } from '@/i18n/useI18n';

const MAP: Record<OverallStatus, { cls: string; icon: ReactNode; color: string }> = {
  IN_PROGRESS: {
    cls: 'dr-overall--progress',
    icon: <ClockCircleOutlined aria-hidden="true" />,
    color: 'var(--ol-processing)',
  },
  UNDER_REVIEW: {
    cls: 'dr-overall--review',
    icon: <EyeOutlined aria-hidden="true" />,
    color: 'var(--ol-info)',
  },
  COMPLETE: {
    cls: 'dr-overall--complete',
    icon: <CheckCircleFilled aria-hidden="true" />,
    color: 'var(--ol-positive)',
  },
};

/**
 * The plain-language overall-status banner. This is the "kills silent-wait abandonment" surface at a
 * glance — an applicant should never wonder whether anything is happening.
 */
export function OverallBanner({ status }: { status: OverallStatus }) {
  const { t } = useI18n();
  const m = MAP[status];
  return (
    <div className={`dr-overall ${m.cls}`} role="status">
      <span className="dr-overall__icon" style={{ color: m.color }}>
        {m.icon}
      </span>
      <span className="dr-overall__body">
        <span className="dr-overall__label">{t(`overall.${status}.label`)}</span>
        <span className="dr-overall__hint"> — {t(`overall.${status}.hint`)}</span>
      </span>
    </div>
  );
}
